import React, { Suspense } from 'react'
import { ThemeProvider } from 'styled-components'

import { LightTheme } from 'ui/bend'

import ThemeWrapper from './ThemeWrapper'
const VideoPlayer = React.lazy(() =>
  import(/* webpackChunkName: 'video-player' */ 'components_v2/VideoPlayer')
)

/*
This component is used as a shim to load the new Footer in old non-redesigned pages
*/

const StyledVideoPlayer = (props) => {
  return (
    <ThemeProvider theme={LightTheme}>
      <ThemeWrapper color='primary'>
        <Suspense fallback={<></>}>
          <VideoPlayer {...props} />
        </Suspense>
      </ThemeWrapper>
    </ThemeProvider>
  )
}

export default StyledVideoPlayer
